import React from 'react';
import { Route, IndexRoute } from 'react-router';
import BreadCrumb from '../Common/BreadCrumb';
import VoucherActivationPage from '../StaticPage/VoucherActivation';

const PageWrapper = (props) => {
  return (
    <div>
      {props.banner}
      <BreadCrumb {...props}/>
      <div className='mb-6'/>
        <VoucherActivationPage {...props}/>
    </div>
  );
};

const Routes = (
  <Route
    label='Prepaid'
    helmet={{
      title: 'Prepaid',
      metaDescription: 'Prepaid'
    }}
    path='prepaid'>
      <Route path='activation'>
        <IndexRoute component={(PageWrapper)} />
      </Route>
  </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/VoucherActivationRoutes.js